/* eslint-disable prefer-destructuring */
import * as XLSX from 'xlsx';
import { isInteger } from 'lodash';

export class ImportCSVTool {

    constructor() {
        this.supportedLocale = ['en', 'fr'];

        //Supported file extension of this import system
        this.supportedFileExtension = ['csv','xlsx','tsv','ods'];
    }

    getSupportedLocale() {
        return this.supportedLocale;
    }

    getSupportedFileExtension() {
        return this.supportedFileExtension;
    }

    getHeaderAndSampleFromParseData = (parseData, sampleSize = 3) => {
        //select the sample size, if the given one is more thant the csv size without header we use csv size minus one
        const nbSample = (parseData.length - 1) < sampleSize ? parseData.length : sampleSize + 1;
        const truncatedColumnsArray = parseData[0].map((header, index) => {
            const sampleRows = parseData.slice(1,nbSample);
            const truncatedColumn = { [header]: sampleRows.map(row => row[index]) };
            return truncatedColumn;
        });
        const headerAndSampleObj = truncatedColumnsArray.reduce(
            (obj, item) => Object.assign(obj, item, {}), {}
        );
        return headerAndSampleObj;
    };

    getHeaderAndDataFromParseData = (parseData) => {
        const ColumnsArray = parseData[0].map((header, index) => {
            const columnData = parseData.map(row => row[index]).slice(1);
            const Column = { [header]: columnData };
            return Column;
        });
        const headerAndSampleObj = ColumnsArray.reduce(
            (obj, item) => Object.assign(obj, item, {}), {}
        );
        return headerAndSampleObj;
    };

    parseSheetAsJson(data) {
        const workbook = XLSX.read(data, { type: 'binary', raw: true });
        const wsname = workbook.SheetNames[0];
        const ws = workbook.Sheets[wsname];
        /* Convert array to json */
        const dataParse = XLSX.utils.sheet_to_json(ws, { header: 1, raw: false });
        return dataParse;
    }

    parseColumnAsInt(column, required, localeCode) {
        const errors = [];
        const parsedColumn = column.map((item, index) => {
            if ((!item || item === 'Undefined') && required) {
                errors.push( (index + 2) + ' : empty');
                return undefined;
            } else if (item === 'Undefined' || !item) {
                return undefined;
            }
            const itemParsed = localeCode === 'en' ? parseInt(item.replace(',','')) : parseInt(item);
            if (isNaN(itemParsed)) {
                errors.push( (index + 2) + ' : Not a number');
                return undefined;
            } else if (itemParsed < 0) {
                errors.push( (index + 2) + ' : Negative number');
                return undefined;
            } else if (!isInteger(itemParsed)) {
                errors.push( (index + 2) + ' : Not a integer');
                return undefined;
            }
            return itemParsed;

        });
        return { parsedColumn, errors };
    }

    parseColumnAsFloat(column, required, localeCode) {
        const errors = [];
        const parsedColumn = column.map((item, index) => {
            if ((!item || item === 'Undefined' || item === 'undefined') && required) {
                errors.push( (index + 2) + ' : empty');
                return undefined;
            } else if (item === 'Undefined' || item === 'undefined' || !item) {
                return undefined;
            }
            const itemParsed = localeCode === 'en' ? parseFloat(item.replace(',','')) : parseFloat(item);
            if (isNaN(itemParsed)) {
                errors.push( (index + 2) + ' : Not a number');
                return undefined;
            } else if (itemParsed < 0) {
                errors.push( (index + 2) + ' : Negative number');
                return undefined;
            }
            return itemParsed;

        });
        return { parsedColumn, errors };
    }

    parseColumnAsString(column, required) {
        const errors = [];
        const parsedColumn = column.map((item, index) => {
            if ((!item || item === 'Undefined') && required) {
                errors.push( (index + 2) + ' : empty');
                return undefined;
            } else if (!item || item === 'Undefined') {
                return undefined;
            }
            return String(item);

        });
        return { parsedColumn, errors };
    }

    parseColumnAsSiteURL(column, required) {
        const errors = [];
        //The patch is necessary cause in the database the site url could be sitename.fr or http://sitename.fr or https://sitename.fr
        //But the article url should be http://sitename.fr or https://sitename.fr
        // const parsedSiteURL = siteURL.split('://');
        // const formatedSiteURL = parsedSiteURL[parsedSiteURL.length - 1];
        const parsedColumn = column.map((item, index) => {
            if ((!item || item === 'Undefined' || item === 'Not Sold') && required) {
                errors.push((index + 2) + ' : empty');
                return undefined;
            } else if (item === 'Undefined' || !item) {
                return undefined;
            }
            return String(item);

        });
        return { parsedColumn, errors };
    }

    oldHeaderStillHere(headerAndSampleObj1, headerAndSampleObj2) {
        let headerAndSampleObj1Keys = Object.keys(headerAndSampleObj1);
        headerAndSampleObj1Keys = headerAndSampleObj1Keys.filter(header => typeof headerAndSampleObj2[header] !== 'undefined');
        return headerAndSampleObj1Keys.length === Object.keys(headerAndSampleObj2).length;
    }

    findDuplicateHeader(parseData) {
        const count = header =>
            header.reduce((a, b) => ({
                ...a,
                [b]: (a[b] || 0) + 1
            }), {});// don't forget to initialize the accumulator

        const duplicates = dict => Object.keys(dict).filter((a) => dict[a] > 1);
        return duplicates(count(parseData[0]));
    }

    parsingHasError(matchings) {
        const errors = Object.entries(matchings).flatMap((matching) => matching[1].errors);
        return errors.length > 0;
    }

    createAttributeRulesObject = (matchings, keys) => {
        let attributeRules = [{
            name: 'input_field_rules',
            values: ['IGNORE', 'CREATE'],
            attributes: []
        }, {
            name: 'spe_field_rules',
            values: ['IGNORE', 'DELETE'],
            attributes: []
        }, {
            name: 'field_match_rules',
            values: ['IGNORE', 'DELETE', 'UPDATE', 'UPDATE_NON_EMPTY'],
            attributes: []
        }];

        attributeRules = attributeRules.map(rule => {
            const attributes = [];
            switch (rule.name) {
            case 'input_field_rules':
                Object.keys(matchings).forEach(m => {
                    if (matchings[m].header !== '') {
                        attributes.push({ name: !matchings[m].siteName ? m : matchings[m].siteName, header: matchings[m].header, value: 'CREATE' });
                    }
                });
                break;
            case 'spe_field_rules':
                Object.keys(matchings).forEach(m => {
                    if (matchings[m].header === '') {
                        attributes.push({ name: !matchings[m].siteName ? m : matchings[m].siteName, header: matchings[m].header, value: 'IGNORE' });
                    }
                });
                break;
            case 'field_match_rules':
                Object.keys(matchings).forEach(m => {
                    if (matchings[m].header !== '' && !keys.includes(m)) {
                        attributes.push({ name: !matchings[m].siteName ? m : matchings[m].siteName, header: matchings[m].header, value: 'UPDATE_NON_EMPTY' });
                    }
                });
                break;
            default:
            }

            rule.attributes = attributes;
            return rule;
        });

        return attributeRules;
    };

    createMatchingsObject = (account, customAttributes) => {
        // The category attribute is considered required in the whole system. However, in import it is not required.
        // If it is absent the category of the article will be set to n/a.
        // First delete category_id from requiered attribute
        const specialImportRequiredAttributes = account.speConfig.requiredAttributes;
        const categoryIdIndex = specialImportRequiredAttributes.findIndex(attribute => attribute.name === 'category_id');
        if (categoryIdIndex > -1) {
            specialImportRequiredAttributes.splice(categoryIdIndex, 1);
        }
        // Then add category in optionnal attribute
        const specialImportOptionnalAttributes = account.speConfig.optionalAttributes;
        specialImportOptionnalAttributes.unshift({ name: 'category', type: 'String' });

        // Create array of matching object
        const requiredAttributes = specialImportRequiredAttributes.map(attribute => ({ [attribute.name]: { header: '', required: true, type: attribute.type, errors: [], parsedData: [], numberFormat: 'fr' } }));
        const optionnalAttributes = specialImportOptionnalAttributes.map(attribute => ({ [attribute.name]: { header: '', required: false, type: attribute.type, errors: [], parsedData: [], numberFormat: 'fr' } }));
        const sitesURLMatchings = account.speConfig.sites.map((site) => ({ [site.name]: { header: '', required: false, site: true, type: site.url, siteName: site.name, errors: [], parsedData: [] } }));
        const customAttributesMatchings = customAttributes.map(attribute => ({ [attribute]: { header: '', required: false, type: 'String', errors: [], parsedData: [], numberFormat: 'fr' } }));
        const matchings = requiredAttributes.concat(optionnalAttributes).concat(sitesURLMatchings).concat(customAttributesMatchings);

        // Then reduce it in one object
        return matchings.reduce((obj, item) => {
            const newItem = Object.assign({}, item);
            return Object.assign(obj, newItem);
        }, {});
    };

    getAdditionalDatasName = () => ['id', 'name', 'brand', 'color', 'size', 'img_url'];

    createAdditionalDatasMatching = () => {

        const dataFormat = this.getAdditionalDatasName();
        let matchings = {};

        dataFormat.forEach(value => {
            const match = {
                errors: [],
                header: '',
                parsedData: [],
                required: value === 'id',
                type: 'string'
            };
            matchings = { ...matchings, [value]: match };
        });

        return matchings;

    };
}

export default new ImportCSVTool();
